<template>
  <div>
    <div
      v-for="(creditor, index) in statement.subjects.creditors"
      :key="creditor + index + Math.random()"
    >
      <div class="form-base__title preview break">
        {{ `Кредитор №${index + 1}` }}
      </div>

      <Subject :statement="statement" :subject="creditor" />
    </div>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';

export default {
  name: 'Step2',
  components: {
    Subject,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
};
</script>
